// Point d'entrée de l'application web WANGRE.
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import './app/i18n';
import { createQueryClient } from './app/query-client';
import { router } from './app/router';
import { ThemeProvider } from './app/theme';

async function enableMocks(): Promise<void> {
  // Mode API simulée (ADR 0014) : données du fil rouge, pour la démonstration et les tests sans API.
  if (import.meta.env.VITE_API_MOCKS !== 'true') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({ quiet: true });
}

const queryClient = createQueryClient();

void enableMocks().then(() => {
  const root = document.getElementById('root');
  if (!root) throw new Error('Élément #root introuvable.');
  createRoot(root).render(
    <StrictMode>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>,
  );
});
